/* eslint-disable import/prefer-default-export */
import TYPES from 'Catalog/types';

export const clearSearch = () => ({
  type: TYPES.CLEAR_SEARCH,
});
